import React from 'react';

import { PageContent } from '../../shared/PageContent';
import { PageDetails } from '../../../models/page';

const styles = {
  main: {
    display: 'flex',
    flexWrap: 'nowrap' as const,
    justifyContent: 'center',
  },
};

export const PreviewPage = ({
  pageDetails,
}: {
  pageDetails: PageDetails;
}): React.ReactElement => {
  return (
    <div style={styles.main}>
      <PageContent pageDetails={pageDetails} />
    </div>
  );
};
